import { render } from "./EditCategorie.vue?vue&type=template&id=0547e29c&ts=true"
import script from "./EditCategorie.vue?vue&type=script&lang=ts"
export * from "./EditCategorie.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__